module.exports = __webpack_public_path__ + "e5362c6f2e8d4fbe025c57116ee31aa3.MP3";